// pro solid icons (fas)
const icons = [
    'faArrowAltRight',
    'faBookmark',
    'faCaretDown',
    'faCaretUp',
    'faCircle',
    'faColumns',
    'faDollarSign',
    'faSortDown',
    'faFilter',
    'faGlobeAmericas',
    'faMapMarkerAlt',
    'faPeoplePantsSimple',
    'faPeopleRoof',
    'faStar',
    'faStarHalfAlt',
    'faSort',
    'faSortUp',
    'faUnlock',
    'faUsers',
    'faPersonCirclePlus',
    'faFlask',
    'faHeading',
];

// Import all icons
import * as iconsModule from '@fortawesome/pro-solid-svg-icons';

export default (library) => {
    // Add all icons to the library
    icons.forEach((iconName) => {
        if (iconsModule[iconName]) {
            library.add(iconsModule[iconName]);
        }
    });
};
